import { Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Language {
  code: string;
  label: string;
  flag: string;
  dir: 'ltr' | 'rtl';
}

@Injectable({ providedIn: 'root' })
export class LanguageService {
  readonly languages: Language[] = [
    { code: 'en', label: 'English', flag: '🇬🇧', dir: 'ltr' },
    { code: 'ar', label: 'العربية', flag: '🇸🇦', dir: 'rtl' },
    { code: 'ur', label: 'اردو', flag: '🇮🇳', dir: 'rtl' },
  ];

  readonly currentLang = signal<string>('en');

  constructor(private translate: TranslateService) {
    const saved = localStorage.getItem('app_lang') ?? 'en';
    this.setLanguage(saved);
  }

  setLanguage(code: string): void {
    const lang = this.languages.find(l => l.code === code) ?? this.languages[0];
    this.translate.use(lang.code);
    this.currentLang.set(lang.code);
    localStorage.setItem('app_lang', lang.code);
    document.documentElement.lang = lang.code;
    document.documentElement.dir = lang.dir;
  }

  currentLanguage(): Language {
    return this.languages.find(l => l.code === this.currentLang()) ?? this.languages[0];
  }
}
